import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[JB+ Payment] Uncaught error:", error, info);
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{
          minHeight: "100vh", background: "#FFFFFF", color: "#212121",
          display: "flex", flexDirection: "column", alignItems: "center",
          justifyContent: "center", padding: 32, fontFamily: "Inter, sans-serif",
          gap: 16, textAlign: "center",
        }}>
          <div style={{
            width: 64, height: 64, borderRadius: "50%",
            background: "rgba(229,57,53,0.15)", border: "2px solid #e53935",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 28,
          }}>⚠️</div>
          <h2 style={{ margin: 0, fontSize: 22 }}>Something went wrong</h2>
          <pre style={{
            background: "#F6F6F6", border: "1px solid #E0E0E0",
            borderRadius: 8, padding: "14px 18px", fontSize: 13,
            color: "#C62828", maxWidth: 600, overflowX: "auto",
            textAlign: "left", whiteSpace: "pre-wrap", wordBreak: "break-word",
          }}>
            {this.state.error.message}
          </pre>
          <p style={{ color: "#666666", fontSize: 14, maxWidth: 480 }}>
            Check the browser console for details. Most likely cause: missing
            <code style={{ background: "#F6F6F6", padding: "2px 6px", borderRadius: 4 }}>
              REACT_APP_FIREBASE_APP_ID
            </code>{" "}
            in <code style={{ background: "#F6F6F6", padding: "2px 6px", borderRadius: 4 }}>
              janmabhoomi-payment/.env
            </code>
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: "#0171BB", border: "none", color: "#fff",
              borderRadius: 8, padding: "10px 24px", fontSize: 14,
              fontWeight: 700, cursor: "pointer",
            }}
          >
            Reload
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
